

export default function SingleMattressIcon({ className }) {
    return <svg className={className} width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.89583 19.562L16.1042 19.562C16.5989 19.562 17 19.1609 17 18.6662L17 1.45785C17 0.963091 16.5989 0.562012 16.1042 0.562012L1.89583 0.562012C1.40108 0.562012 1 0.963091 1 1.45785L1 18.6662C1 19.1609 1.40108 19.562 1.89583 19.562Z" stroke="currentColor" strokeWidth="0.716667" />
    </svg>

}